export const BUILD_VERSION = '1790336804';
